import {Injectable} from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    CanActivateChild,
    CanLoad,
    Route,
    RouterStateSnapshot,
    UrlSegment,
    UrlTree
} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthGuardService} from "../services/auth-guard.service";

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {

    constructor(private _authGuardService: AuthGuardService) {
    }

    // -----------------------------------------------------------------------------------------------------
    // canActivate
    // -----------------------------------------------------------------------------------------------------
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        const redirectUrl = state.url === '/sign-out' ? '/' : state.url;
        return this._check(redirectUrl);
    }

    // -----------------------------------------------------------------------------------------------------
    // canActivateChild
    // -----------------------------------------------------------------------------------------------------
    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        const redirectUrl = state.url === '/sign-out' ? '/' : state.url;
        return this._check(redirectUrl);
    }

    // -----------------------------------------------------------------------------------------------------
    // canLoad
    // -----------------------------------------------------------------------------------------------------
    canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
        return this._check('/');
    }

    // -----------------------------------------------------------------------------------------------------
    // _check
    // -----------------------------------------------------------------------------------------------------
    private _check(redirectURL: string): Observable<boolean> {
        return this._authGuardService.check(redirectURL, true);
    }
}
